
import { defineComponent } from 'vue'

import Done from '@/components/Done.vue'
import TileBlur from '@/components/TileBlur.vue'
import TPTileBlurAbsolute from '@/components/TileBlurAbsolute.vue'

export default defineComponent({
  name: 'TPTile',
  props: {
    x: Number,
    y: Number,
    oldX: Number,
    oldY: Number,
    merged: Boolean,
    new: Boolean,
    value: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: 'cpu',
    },
    isAbsolute: {
      type: Boolean,
      default: true,
    },
    done: {
      type: Boolean,
      default: false,
    },
    isHard: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    'tp-tile-blur': TileBlur,
    'tp-tile-blur-absolute': TPTileBlurAbsolute,
    'tp-done': Done,
  },
  data: function () {
    return {
      types: {
        gpu: 'gpu',
        ram: 'ram',
        hdd: 'hdd',
        cpu: 'cpu',
      },
      colors: {
        cpu: {},
      },
    }
  },
  computed: {
    classes(): any[] {
      let classArray = ['tp-tile']
      const value = this.value as any
      classArray.push(`tile_` + value)

      if (this.isAbsolute === true) {
        classArray.push('tp-tile__absolute')

        if (this.merged === true) {
          classArray.push('tile__merged')
        }

        if (this.new === true) {
          classArray.push(`tile__new_x${this.x}_y${this.y}`)
        }

        classArray.push(`tile_position_${this.x}_${this.y}`)
        classArray.push(`tile_move_from_x${this.oldX}_y${this.oldY}_to_x${this.x}_y${this.y}`)
      } else {
        classArray.push('tp-tile__target')
      }

      return classArray
    },
    color(): string {
      //@ts-ignore
      return this.getColor(this.value, this.type)
    },
    tileImage(): any {
      let path = '../assets/'

      if (!this.isAbsolute) {
        path = path + '2x/'
      }

      if (this.type !== '') {
        path = path + this.type + '/'
      }

      const value = this.value.toString()

      const fileName = `${path}x${value}.png`

      return require(fileName)
    },
  },
  methods: {
    isImageVisible(min: number, max: number, type: string): boolean {
      let isVisible = false
      let value = this.value || 0

      if (value > min && value <= max && this.type === type) {
        isVisible = true
      }

      return isVisible
    },
    tileClasses(value: number, type: string): string[] {
      let classes = ['tile__inner ']
      let typeClass = 'tile__'

      if (type === this.types.cpu) {
        typeClass = typeClass + 'cpu__'
      }

      if (type === this.types.ram) {
        typeClass = typeClass + 'ram__'
      }

      if (type === this.types.hdd) {
        typeClass = typeClass + 'hdd__'
      }

      if (type === this.types.gpu) {
        typeClass = typeClass + 'gpu__'
      }

      typeClass = typeClass + value.toString()

      classes.push(typeClass)

      if (this.isAbsolute === true) {
        classes.push('tp-tile__inner-absolute')
      } else {
        classes.push('tp-tile__inner-target')
      }

      return classes
    },
    tileImageClasses(value: number, type: string): any {
      let classes = ['tile__image']
      let typeClass = 'tile__image-'

      if (type === this.types.cpu) {
        typeClass = typeClass + 'cpu__'
      }

      if (type === this.types.ram) {
        typeClass = typeClass + 'ram__'
      }

      if (type === this.types.hdd) {
        typeClass = typeClass + 'hdd__'
      }

      if (type === this.types.gpu) {
        typeClass = typeClass + 'gpu__'
      }

      typeClass = typeClass + value.toString()
      classes.push(typeClass)

      if (this.isAbsolute === false) {
        classes.push(typeClass + '--target')
      }

      if (this.isHard === true) {
        classes.push('tile__image-is--hard')
      }

      classes.push('tile__image-load')

      return classes
    },
    getColor(value: number, type: string): string {
      let color = '#000'

      if (type === this.types.cpu) {
        if (value === 2) {
          color = '#B2BEC1'
        }

        if (value === 4) {
          color = '#B1D0DA'
        }

        if (value === 8) {
          color = '#A2D2E1'
        }

        if (value === 16) {
          color = '#8DD7EE'
        }

        if (value === 32) {
          color = '#75DEFF'
        }

        if (value === 64) {
          color = '#5FD8FF'
        }

        if (value === 128) {
          color = '#30CDFF'
        }

        if (value === 256) {
          color = '#25C7FA'
        }

        if (value === 512) {
          color = '#00C2FF'
        }

        if (value === 1024) {
          color = '#00C2FF'
        }

        if (value === 2048) {
          color = '#00C2FF'
        }
      }

      if (type === this.types.gpu) {
        if (value === 2) {
          color = '#B2C1B5'
        }

        if (value === 4) {
          color = '#B1DAB8'
        }

        if (value === 8) {
          color = '#A2E1AD'
        }

        if (value === 16) {
          color = '#8DEE9D'
        }

        if (value === 32) {
          color = '#75FF8C'
        }

        if (value === 64) {
          color = '#5FFF79'
        }

        if (value === 128) {
          color = '#30FF52'
        }

        if (value === 256) {
          color = '#25FA49'
        }

        if (value === 512) {
          color = '#00FF2A'
        }

        if (value === 1024) {
          color = '#00FF2A'
        }

        if (value === 2048) {
          color = '#00FF2A'
        }
      }

      if (type === this.types.ram) {
        if (value === 2) {
          color = '#B8B2C1'
        }

        if (value === 4) {
          color = '#C1B1DA'
        }

        if (value === 8) {
          color = '#BAA2E1'
        }

        if (value === 16) {
          color = '#B28DEE'
        }

        if (value === 32) {
          color = '#AA75FF'
        }

        if (value === 64) {
          color = '#9C5FFF'
        }

        if (value === 128) {
          color = '#7F30FF'
        }

        if (value === 256) {
          color = '#7725FA'
        }

        if (value === 512) {
          color = '#6200FF'
        }

        if (value === 1024) {
          color = '#6200FF'
        }

        if (value === 2048) {
          color = '#6200FF'
        }
      }

      if (type === this.types.hdd) {
        if (value === 2) {
          color = '#B2C1C0'
        }

        if (value === 4) {
          color = '#B1DAD7'
        }

        if (value === 8) {
          color = '#A2E1DD'
        }

        if (value === 16) {
          color = '#8DEEE8'
        }

        if (value === 32) {
          color = '#75FFF6'
        }

        if (value === 64) {
          color = '#5FFFF4'
        }

        if (value === 128) {
          color = '#5FFFF4'
        }

        if (value === 256) {
          color = '#25FAEC'
        }

        if (value === 512) {
          color = '#00FFEE'
        }

        if (value === 1024) {
          color = '#00FFEE'
        }

        if (value === 2048) {
          color = '#00FFEE'
        }
      }

      return color
    },
    getTileStyle(): Object {
      //@ts-ignore
      let color = this.getColor(this.value, this.type)
      let style = {
        background: '',
      }

      if (this.value > 256) {
        style.background = color
      }

      return style
    },
    getTileValueClasses(): string {
      let classes = 'tile__inner-value'
      return classes
    },
    isAbsoluteTile(): boolean {
      if (this.isAbsolute === true) {
        return true
      }

      return false
    },
  },
})
